import { TERMINAL_STATUSES } from '../Lib/redux/sagas/GetLeadStatus/getLeadStatus';

/**
 * Whether the lead-status poll has seen Outreach end the journey (a
 * TERMINAL_STATUSES status). The FINISHED + TIMEOUT cutoff is not included: it
 * only stops the poll and clears isBookingConfirmable, so the review screen's
 * Confirm refuses it and reportBookingNotConfirmable reports TIMEOUT /
 * TERMINAL_CUTOFF.
 */
export const selectHasLeadStatusFailed = (state) =>
  TERMINAL_STATUSES.includes(state.clientApiJourney?.leadStatus?.status);

export const selectLeadStatusMessageKey = (state) =>
  state.clientApiJourney?.leadStatus?.messageKey;
